import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';

const UserDetailScreen = lazy(() =>
  import('../screens/Users/UserDetailScreen').then(m => ({ default: m.UserDetailScreen })),
);

export const Route = createFileRoute('/users/$id')({
  component: UserDetailPage,
});

function UserDetailPage() {
  return (
    <Suspense fallback={<div style={{ padding: 32, color: 'var(--lca-gray-500)', fontSize: 13 }}>Loading…</div>}>
      <UserDetailScreen />
    </Suspense>
  );
}
